export default "__VITE_ASSET__BOTRYZOS__"